$(function() {

	$('.block.checklist .checklist-item').each(function() {

		$(this).disableSelection();

		var $block = $(this).parents('.block'),
			$item = $(this),
			$input = $item.find('input'),
			min = $input.attr('minlength') ? parseInt($input.attr('minlength')) : 0,
			max = $input.attr('maxlength') ? parseInt($input.attr('maxlength')) : null;

		$item.on('click', function(e) {
			if (max === 1) {
				if ($item.hasClass('checked')) {
					e.stopPropagation();
					return false;
				}
				$block.find('.checklist-item.checked').not($item).each(function() {
					$(this).find('input').prop('checked', false);
					$(this).removeClass('checked');
				});
			}
			else if (!$input.prop('checked') && $block.find('input:checked').length >= max && max > 1) {
				return false;
			}
		});

		$input.on('change', function() {
			$item[$input.prop('checked') ? 'addClass' : 'removeClass']('checked');
			setTimeout(function() {
				$block.trigger('selected');
			}, 100);
		});

	});

});